class AuditoriaIntegradaSyncModal {
  constructor($filter, $scope, gql) {
    const calculaDias = day => day * 24 * 60 * 60 * 1000
    const today = new Date()

    this.gql = gql
    this.apply = fun => $scope.$applyAsync(fun)
    this.loading = false
    this.filter = {
      inicio: new Date(today.getTime() - calculaDias(90)),
      fim: today
    }

    this.$filter = $filter
    this.errorMessage = false
  }

  sync(form) {
    if (form.$valid) {
      this.errorMessage = false
      const mutation = gql`
        mutation SyncAuditoriaIntegrada($empresaId: String!, $inicio: Date!, $fim: Date!, $filialId: Int!) {
          empresa(id: $empresaId) {
            extratos: syncAuditoriaIntegrada(inicio: $inicio, fim: $fim, filialId: $filialId) {
              numero
            }
          }
        }
      `
      const inicio = this.formatDate(this.filter.inicio)
      const fim = this.formatDate(this.filter.fim)
      const empresaId = this.resolve.contratoId.toString()
      const filialId = parseInt(this.resolve.empresaId)

      this.promise = this.gql
        .mutate(mutation, { empresaId, inicio, fim, filialId })
        .then(({ empresa: { extratos } }) => {
          Alert.success(`${extratos.length} extratos sincronizados com sucesso.`, "Sucesso")
          this.close()
        })
        .catch(resp => {
          this.errorMessage = "Tente novamente mais tarde."
        })
        .then(() => this.apply())
    }
  }

  formatDate(date) {
    return this.$filter('date')(date, 'yyyy-MM-dd')
  }

  validade(form) {
    let { inicio, fim } = this.filter

    form.fim.$setValidity("tooHigh", true)
    form.inicio.$setValidity("tooHigh", true)

    if (inicio && fim) {
      diferenca = this.timeToDays(fim.getTime() - inicio.getTime())

      inicio = this.formatDate(inicio)
      fim = this.formatDate(fim)

      form.fim.$setValidity("tooHigh", diferenca <= 90)
      form.inicio.$setValidity("tooHigh", inicio <= fim)
    }
  }

  timeToDays(time) {
    return time / 24 / 60 / 60 / 1000
  }
}

angular.module('eficienciaFiscalModule').component('auditoriaIntegradaSyncModal', {
  controller: ['$filter', '$scope', 'gql', AuditoriaIntegradaSyncModal],
  bindings: {
    close: '&',
    resolve: '<'
  },
  template: `
    <promise-tracker promise="$ctrl.promise" active="$ctrl.loading">
      <form name="form" ng-submit="$ctrl.sync(form)">
        <modal modal-title="Sincronização manual" close="$ctrl.close">
          <modal-body>
            <loading promise="$ctrl.promise">
              <div class="row">
                <div class="form-group col-sm-6">
                  <label>
                    Data vencimento inicial
                    <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.inicio = undefined"
                      ng-if="$ctrl.filter.inicio">
                    </i>
                  </label>
                  <input type="text" form="form" class="form-control" name="inicio" ng-model="$ctrl.filter.inicio"
                    ng-required="true" ng-change="$ctrl.validade(form)" ui-date>
                  <small ng-show="form.inicio.$error.tooHigh" class="text-danger">Data inicial deve ser menor que a data
                    final</small>
                  <small ng-show="form.inicio.$error.required" class="text-danger">Campo obrigatório</small>
                </div>
                <div class="form-group col-sm-6">
                  <label>
                    Data vencimento final
                    <i class="fa fa-trash-o text-danger cursor-pointer" ng-click="$ctrl.filter.fim = undefined"
                      ng-if="$ctrl.filter.fim">
                    </i>
                  </label>
                  <input type="text" form="form" class="form-control" name="fim" ng-model="$ctrl.filter.fim"
                    ng-required="true" ng-change="$ctrl.validade(form)" ui-date>
                  <small ng-show="form.fim.$error.tooHigh" class="text-danger">Data final não pode ser maior que 90
                    dias</small>
                  <small ng-show="form.fim.$error.required" class="text-danger">Campo obrigatório</small>
                </div>
                <div class="col-xs-12" ng-show="$ctrl.errorMessage">
                  <highlighted class="text-danger">
                    <main>Ocorreu um erro na sua requisição.</main>
                    <secondary>{{$ctrl.errorMessage}}</secondary>
                  </highlighted>
                </div>
              </div>
            </loading>
          </modal-body>
          <modal-footer>
            <button class="btn btn-primary" ng-disabled="$ctrl.loading">Sincronizar <i class="fa fa-refresh"></i></button>
            <button class="btn btn-default" type="button" ng-disabled="$ctrl.loading"
              ng-click="$ctrl.close()">Fechar</button>
          </modal-footer>
        </modal>
      </form>
    </promise-tracker>
  `
})
